import { SpeedType } from "../multigame/api";

export interface IBackendSettingsService
{
    GetNum(key: string, defaultValue?: number): number;
    GetBool(key: string, defaultValue?: boolean): boolean
    GetEnum<T>(key: string, defaultValue?: T): T;
    GetString(key: string, defaultValue?: string): string;
}


export class BackendSettingsService implements IBackendSettingsService
{
    protected values = {
        "system.defaultVolume": 2,
        "play.turbo": false,
        "play.speedtype": SpeedType.Type1,
        "accounting.payoutButton": false,
    };

    public GetNum(key: string, defaultValue?: number): number
    {
        let val = this.values[key] ?? defaultValue;
        if (val === undefined)
        {
            throw `Undefined settings numeric value for ${key}`;
        }

        return val;
    }

    public GetBool(key: string, defaultValue?: boolean): boolean
    {
        let val = this.values[key] ?? defaultValue;

        if (val === undefined)
        {
            throw `Undefined settings boolean value for ${key}`;
        }

        return val;
    }

    public GetEnum<T>(key: string, defaultValue?: T): T
    {
        let val = this.values[key] ?? defaultValue;

        if (val === undefined)
        {
            throw `Undefined settings boolean value for ${key}`;
        }

        return val as T;
    }
    public GetString(key: string, defaultValue?: string): string
    {
        let val = this.values[key] ?? defaultValue;

        if (val === undefined)
        {
            throw `Undefined settings boolean value for ${key}`;
        }

        return val;
    }
}



